<main class="main-grid">

  <div class="bonuses">
    <div class="card">
      <div class="bonuses__containter">
        <h2>Premiowane transakcje: {{ userData ? userData.sellThisMonth : '' }}</h2>

        <div class="bonuses__item">
          <div class="icon-holder">
            <i class="icon-star icon-color--magenta"></i>
            <span class="icon-name-tag icon-color--magenta">Premia</span>
          </div>
          <div class="bonuses__result icon-color--magenta" *ngIf="userData && userData.userWallets && userData.userWallets.length > 0">{{ userData.userWallets[0].balance }}</div>
        </div>



        <h2>Zadania dnia</h2>
        <span class="premia-info" *ngIf="userData && !userData.hasSellThisMonth">Premia będzie dostępna po 3 premiowanych transakcjach</span>
        <div class="bonuses__item {{ userData && userData.hasSellThisMonth || blinking ? '' : 'disabled' }}">
          <div class="icon-holder">
            <i [class.blinking]="blinking" class="icon-star-reversed icon-color--yellow"></i>
            <span [class.blinking]="blinking" class="icon-name-tag icon-color--yellow">Premia</span>
          </div>
          <div [class.blinking]="blinking" class="bonuses__result icon-color--yellow" *ngIf="userData && userData.userWallets && userData.userWallets.length > 1">{{ lastUserPoints }}</div>
<!--          userData.userWallets[1].balance-->
        </div>

      </div>

      <div class="bonuses__button" (click)="button_click()">
        <p>Przelej premie na swoje konto</p>
        <i class="icon-arrow-next icon-color--white"></i>
      </div>


    </div>
  </div>
</main>
